declare const __VERSION_PUSH_NOTIFICATIONS__: string;
export const version = __VERSION_PUSH_NOTIFICATIONS__;

export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_PROD = !IS_DEV;
export const IS_STAGE_DEV =
  typeof window !== 'undefined' &&
  window.location.hostname.indexOf('devmail.ru') !== -1;

export const getENV = () => (IS_DEV || IS_STAGE_DEV ? 'dev' : 'prod');
